module.exports = __webpack_public_path__ + "static/media/SST_casas.036775a1.PNG";